
import { useState, useEffect } from 'react';
import Header from './components/Header';
import Hero from './components/Hero';
import Services from './components/Services';
import About from './components/About';
import Process from './components/Process';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  useEffect(() => {
    // Schema.org JSON-LD for Professional Service
    const schemaData = {
      "@context": "https://schema.org",
      "@type": "ProfessionalService",
      "name": "芦江土地家屋調査士事務所",
      "description": "大分県全域・近隣地域の土地家屋調査士事務所。土地境界確定、建物表題登記、土地分筆・合筆登記など、不動産測量・登記業務を専門的に行います。",
      "url": import.meta.env.VITE_SITE_URL || "https://example.com",
      "telephone": "050-1726-1703",
      "faxNumber": "050-1809-0843",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "大字江須賀1545番地の4",
        "addressLocality": "宇佐市",
        "addressRegion": "大分県",
        "postalCode": "879-0471",
        "addressCountry": "JP"
      },
      "geo": {
        "@type": "GeoCoordinates",
        "latitude": "33.5347",
        "longitude": "131.3486"
      },
      "openingHours": "Mo-Fr 09:00-18:00",
      "serviceArea": [
        {
          "@type": "State",
          "name": "大分県"
        },
        {
          "@type": "AdministrativeArea",
          "name": "近隣地域"
        }
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "土地家屋調査士サービス",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "土地境界確定測量",
              "description": "隣接地との境界を明確にする測量業務"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "建物表題登記",
              "description": "新築建物の登記申請業務"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "土地分筆登記",
              "description": "一筆の土地を複数に分割する登記業務"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "土地合筆登記",
              "description": "複数の土地を一筆にまとめる登記業務"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "地積更正登記",
              "description": "土地の面積を正確に修正する登記業務"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "Service",
              "name": "建物滅失登記",
              "description": "取り壊した建物の登記抹消業務"
            }
          }
        ]
      },
      "founder": {
        "@type": "Person",
        "name": "芦江諒介",
        "jobTitle": "土地家屋調査士"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "127"
      },
      "priceRange": "$$",
      "sameAs": []
    };

    // Create and append script tag
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(schemaData);
    document.head.appendChild(script);

    // Cleanup function
    return () => {
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        document.head.removeChild(existingScript);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <Hero />
      <Services />
      <About />
      <Process />
      <Contact />
      <Footer />
    </div>
  );
}
